<template>
    <div class="row flex flex-col justify-center pb-0 overflow">
        <div class="w-12/12 md:max-w-full text-center roboto">
            <div v-if="message && (isCableAccessoriesPage || (cablesNeededCount !== totalCablesSubmittedCount))" ref="selectionWrapper" class="error-message-wrapper" :class="messageWrapperClass">
                <div class="error-title-wrapper">
                    <div class="flex">
                        <div class="error-circle">!</div>
                        <h3 class="!text-base">{{ (messageType === 'general' || isCableAccessoriesPage) ? 'Error with your entry' : `${cablesNeededCount - totalCablesSubmittedCount} of ${cablesNeededCount } cables have errors` }}</h3>
                    </div>
                </div>
                <p v-if="message" class="message">{{ message }}</p>
                <button class="change-button" v-if="action && action.text" @click="action.action">{{ action.text }}</button>
            </div>
            <div v-if="totalCablesSubmittedCount > 0" ref="selectionWrapper" class="selected-cable-wrapper">
                <h3>Cable Selections</h3>
                <ul class="cable-list">
                    <li
                        v-for="(info, name) in totalCompiledData"
                        :key="name"
                        class="info-wrapper flex mt-1 text-left"
                    >   
                        <p class="text-base min-w-[45px] dark-blue-text font-normal mt-0 ml-1 mr-2">Qty: {{ info.qty }}</p>
                        <div class="product-info">
                            <p class="text-base font-medium dark-blue-text mt-0" style="line-height: 140%;">{{ name }}</p>
                            <p v-if="info && info.list && info.list.length > 0" class="text-sm dark-blue-text subtext font-normal -mt-0.5">for 
                                <span
                                    v-for="(value, index) in info.list"
                                    :key="value"
                                >
                                    {{ value.replace("undefined", '') }}{{ index !== info.list.length -1 ? ',' : '' }}
                                </span>
                            </p>
                        </div>
                    </li>
                </ul>
                <v-button
                    class="w-12/12 button-wrap !mb-0 h-fit"
                    :class="index === 0 && 'disabled'"
                    position="left"
                    mobile="12"
                    tablet="12"
                    desktop="12"
                    styling="tertiary"
                    :disabled="false"
                    textAlign="left"
                    @onClickEvent="clearTotalCablesSubmittedData"
                    v-if="isCableAccessoriesPage && totalCablesSubmittedCount > 0"
                >
                    <template v-slot:content class="!h-fit">
                        <span class="flex items-center">
                            <svg class="inline" width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4H1V16ZM14 1H10.5L9.5 0H4.5L3.5 1H0V3H14V1Z" fill="#0D6EDE"/>
                            </svg>
                            <span class="underline">{{ webstoreContent.cartPage.clearAll }}</span>
                        </span>
                    </template>
                </v-button>
            </div>
             
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import vButton from '../utils/button';
    import { WebstoreResources } from "../../mixins/webstore-resources";
    export default {
        mixins:[ WebstoreResources ],
        components: {vButton},
        props: {
            shift: {
                required: true,
                default: true,
            },
            cableSkuToNames: {
                required: true,
                default: {},
            },
            isCableAccessoriesPage: {
                required: false,
                default: false
            }
        },
        data() {
            return {
                flash: false,
                errorCablesCount: 0,
            }
        },
        computed: {
            ...mapGetters("content", ["webstoreContent"]),

            ...mapGetters([
                'activeProductKey',
                'activeOfferKey',
            ]),

            cablesNeededCount() {
                return this.$store.getters[`${this.activeProductKey}${this.activeOfferKey}CableSelection/base/cablesNeededCount`];
            },

            message() {
                if (this.$store.getters[`${this.activeProductKey}${this.activeOfferKey}CableSelection/base/cableSelectionMessage`] && 
                    this.$store.getters[`${this.activeProductKey}${this.activeOfferKey}CableSelection/base/cableSelectionMessage`].length > 0) {
                }
                return this.$store.getters[`${this.activeProductKey}${this.activeOfferKey}CableSelection/base/cableSelectionMessage`];
            },

            messageType() {
                return this.$store.getters[`${this.activeProductKey}${this.activeOfferKey}CableSelection/base/cableSelectionMessageType`];
            },

            messageWrapperClass() {
                let messageClass = '';
                if (this.totalCablesSubmittedCount === this.cablesNeededCount) {messageClass += 'valid '}
                if (this.flash) {messageClass += 'flash '}
                return messageClass;
            },

            action() {
                if(this.message && this.message.includes('out of stock') && !this.message.includes('plug type')){
                    return undefined
                }else if (this.message && !this.message.includes('plug type')) {
                    return { text: 'Input MMY', action: () => this.addCableSelectionMethod('mmy') }
                } else if (this.message && this.message.includes('We recommend selecting this cable via plug type.')) {
                    return { text: 'Input Plug Type', action: () => this.addCableSelectionMethod('plug type') }
                }else{
                    return undefined
                }
            },
        },
        methods: {
            changeCableSelectionType(type) {
                this.$emit('change-cable-selection-type', type)
            },

            clearTotalCablesSubmittedData() {
                this.$emit('clear')
            },

            addCableSelectionMethod(method) {
                this.$emit('add-selection-method', method);
                this.setCableSelectionMessage('');
            },

            scrollToMessage() {
                let messageElement = this.$refs['selectionWrapper'];
            
                if (messageElement) {
                    var top = messageElement.offsetTop - 500;

                    window.scrollTo({
                    left: 0,
                    top,
                    behavior: 'smooth',
                    });
                }
            },
        }
    }
</script>

<style scoped>

    @media (min-width: 736px) {
        .selected-cable-wrapper {
            overflow: scroll;
            max-height: 650px;
        }
        .overflow {
            margin: 0 auto;
        }
        .shift {
            margin-left: -55px;
        }
    }

    .error-message-wrapper {
        width: 100%;
        height: fit-content;
        border-radius: 5px;
        padding: 20px;
        margin-top: 20px;
        display: inline-block;
        position: relative;
        border: 3px solid #CD1426;
        border-left: 8px solid #CD1426;
        -webkit-transition: border-color .6s linear; /* Saf3.2+, Chrome */
        -moz-transition: border-color .6s linear; /* FF3.7+ */
        -o-transition: border-color .6s linear; /* Opera 10.5 */
        transition: border-color .6s linear;
    }

    .selected-cable-wrapper {
        width: 100%;
        height: fit-content;
        border-radius: 5px;
        padding: 20px;
        margin-top: 20px;
        display: inline-block;
        position: relative;
        background: #F6F7F9;
    }

    .message {
        font-size: 16px;
        line-height: 130%;
        text-align: left;
        color: #00263E;
        -webkit-transition: color .6s linear; /* Saf3.2+, Chrome */
        -moz-transition: color .6s linear; /* FF3.7+ */
        -o-transition: color .6s linear; /* Opera 10.5 */
        transition: color .6s linear;
    }

    @media (max-width: 736px) {
        .message-wrapper {
            padding: 30px;
        }
    }

    .valid {
        background: #F2F7FF;
        border: 1px solid #F2F7FF;
    }

    .valid h3 {
        color: #00263E !important;
    }

    .error-message-wrapper h3 {
        color: #CD1426;
        margin: 0;
        font-weight: bold;
        text-align: left;
        line-height: 16px !important;
    }

    .error-circle {
        width: 16px;
        height: 16px;
        background-color: #CD1426;
        margin-right: 6px;
        border-radius: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        font-weight: bold;
        font-size: 13px;
        margin-top: -1px;
    }

    .selected-cable-wrapper h3 {
        margin: 0;
        font-weight: bold;
        font-size: 20px;
        line-height: 20px;
        text-align: left;
        border-bottom: 1px solid lightgray;
        padding-bottom: 15px;
    }

    .error-message-wrapper hr {
        border: 1px solid #00263E;
        width: 100%;
        height: 0;
        margin-top: 22px;
        margin-bottom: 15px;
    }

    .qty {
        margin-top: 5px;
    }

    .change-button {
        width: fit-content;
        height: 42px;
        color: #0D6EDE;
        font-size: 16px;
        line-height: 16px;
        margin-top: 10px;
        font-weight: bold;
        text-decoration: underline;
        text-align: right;
        width: 100%;
    }

    .reset {
        position: absolute;
        top: 31px;
        right: 57px;
        text-decoration: underline;
        cursor: pointer;
        font-size: 20px;
    }

    .subtext {
        font-size: 13px;
    }

    .underline {
        text-decoration: underline;
        margin-left: 8px;
    }
/* 
                    <v-button
                    class="w-12/12 button-wrap !mb-0 h-fit"
                    :class="index === 0 && 'disabled'"
                    position="left"
                    mobile="12"
                    tablet="12"
                    desktop="12"
                    styling="tertiary"
                    :disabled="false"
                    textAlign="left"
                    @onClickEvent="clearTotalCablesSubmittedData"
                    v-if="totalCablesSubmittedCount > 0"
                >
                    <template v-slot:content class="!h-fit">
                        <span class="flex items-center">
                            <svg class="inline" width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4H1V16ZM14 1H10.5L9.5 0H4.5L3.5 1H0V3H14V1Z" fill="#0D6EDE"/>
                            </svg>
                            <span class="underline">{{ webstoreContent.cartPage.clearAll }}</span>
                        </span>
                    </template>
                </v-button> */

</style>
